module.exports = "https://static.wmbcdn.com/uniweb/images/52fa73cdc64d28cc924a3af0656b9378.svg";